/* Manu AI v28 (23/10/2026) — parcours en étapes nommées, décliner plus tard.
 * - En-tête : « 1 Création du design · 2 Choix du support » (étape 3, Finalisation, apparaît dans le bandeau de la fiche) + petite barre d'avancement.
 * - « Décliner pour une autre personne » quitte l'écran du design (trop tôt) : une info à l'étape du support, puis le lien du bandeau de la fiche (inst.openDecline).
 * S'appuie sur section._ais enrichie par v9 → v27. */
(function () {
  'use strict';

  var STEPS = {
    fr: ['Création du design', 'Choix du support', 'Finalisation'],
    en: ['Design creation', 'Garment choice', 'Finishing'],
    es: ['Creación del diseño', 'Elección de la prenda', 'Finalización'],
    de: ['Design erstellen', 'Shirt wählen', 'Abschluss'],
    it: ['Creazione del design', 'Scelta del capo', 'Finalizzazione']
  };
  var INFO = {
    fr: 'Une fois ta personnalisation finalisée, tu pourras décliner ce design pour une autre personne depuis la fiche produit.',
    en: 'Once your customisation is finished, you can create a version of this design for someone else from the product page.',
    es: 'Cuando termines la personalización, podrás adaptar este diseño para otra persona desde la ficha del producto.',
    de: 'Sobald deine Personalisierung abgeschlossen ist, kannst du dieses Design auf der Produktseite für eine andere Person abwandeln.',
    it: 'Una volta finalizzata la personalizzazione, potrai declinare questo design per un’altra persona dalla scheda prodotto.'
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v28 || !inst._v27) return;
    inst._v28 = true;
    var dlg = inst.dialog; if (!dlg) return;
    dlg.setAttribute('data-v28', '');
    var steps = dlg.querySelector('[data-ais-steps]'), head = dlg.querySelector('.ais-dialog__head'), MQM = window.matchMedia('(max-width: 749px)');

    /* ---------- Étapes : libellés, barre, dans la première ligne de l'en-tête (ordinateur et mobile) ---------- */
    function place() {
      if (!steps || !head) return;
      var before = head.querySelector('.ais26-dt') || head.querySelector('[data-ais-restart]');
      if (steps.parentNode !== head || steps.nextElementSibling !== before) head.insertBefore(steps, before);
    }
    function labels() {
      if (!steps) return;
      var L = STEPS[inst.loc] || STEPS.fr;
      ['design', 'support', 'custom'].forEach(function (k, i) { var sp = steps.querySelector('[data-step="' + k + '"] span'); if (sp) sp.textContent = L[i]; });
    }
    function progress() {
      if (!steps) return;
      var cur = steps.querySelector('li[data-state="current"]'), order = ['design', 'support', 'custom'];
      var n = cur ? order.indexOf(cur.getAttribute('data-step')) + 1 : 1;
      steps.setAttribute('data-p', String(Math.max(1, n))); dlg.setAttribute('data-v28-p', String(Math.max(1, n)));
    }
    if (steps) {
      place(); labels(); progress();
      new MutationObserver(progress).observe(steps, { attributes: true, attributeFilter: ['data-state'], subtree: true });
      if (MQM.addEventListener) MQM.addEventListener('change', place); else if (MQM.addListener) MQM.addListener(place);
      dlg.addEventListener('ais:locale', function () { setTimeout(labels, 0); });
      var baseStep = inst.setStep; if (baseStep) inst.setStep = function () { var r = baseStep.apply(this, arguments); labels(); return r; };
    }

    /* ---------- Info à l'étape du support (avant « Finaliser la personnalisation ») ---------- */
    inst.v28info = function () { return '<p class="ais28-info">' + esc(INFO[inst.loc] || INFO.fr) + '</p>'; };

    /* ---------- « Retoucher » : ouvre la retouche de la face visée (avant : refaisait toutes les faces) ---------- */
    dlg.addEventListener('click', function (e) {
      var sm = e.target.closest && e.target.closest('.ais-v18__tw > summary'); if (!sm) return;
      var side = inst.s && inst.s.edit, pane = sm.closest('.ais-v18__pane') || dlg;
      var b = pane.querySelector('[data-v24-side="' + side + '"] [data-v24="retouch"]') || pane.querySelector('[data-v24="retouch"]');
      if (!b) return;   // pas de retouche par face possible (logo importé…) : le menu s'ouvre comme avant
      e.preventDefault(); b.click();
      var f = pane.querySelector('.ais24__rt'); if (f && f.scrollIntoView) f.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }, true);

    /* ---------- Décliner : appelé depuis le bandeau de la fiche (le bouton de l'écran du design est masqué) ---------- */
    inst.openDecline = function () {
      var t0 = Date.now();
      (function tick() {
        var b = dlg.querySelector('.ais-v18__pane:not(.is-out) [data-s18="decl"]');
        if (b) { b.click(); return; }
        if (Date.now() - t0 < 5000) setTimeout(tick, 200);
      })();
    };
  }

  function boot(n) {
    n = typeof n === 'number' ? n : 0;
    document.querySelectorAll('[data-ais]').forEach(function (root) {
      var i = root._ais;
      if (i && i._v27) enhance(root);
      else if (n < 40) setTimeout(function () { boot(n + 1); }, 150);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); }); else boot(0);
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { boot(0); }, 10); });
})();
